// extracted by mini-css-extract-plugin
export var checkout = "style-module--checkout--a09ef";
export var content = "style-module--content--f79aa";
export var error = "style-module--error--68490";
export var proceed = "style-module--proceed--dcae4";